import React from "react";
import Flagship from "../../core/flagship";
import Field from "../misc/Field";
import { connect } from "react-redux";
import {
  Table,
  Loader,
  Header,
  Modal,
  Button,
  Select,
  Icon,
} from "semantic-ui-react";
import { shouldShowField, empty } from "../../utils/helpers";
import FlightField from "../misc/FlightField";

class IoProductAdvisrForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.editName = this.editName.bind(this);
    this.onSelectService = this.onSelectService.bind(this);
    this.onSelectSubOption = this.onSelectSubOption.bind(this);
    this.getSubServiceFields = this.getSubServiceFields.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
    this.addError = this.addError.bind(this);
    this.clearError = this.clearError.bind(this);
    this.onChange = this.onChange.bind(this);
    this.checkRequired = this.checkRequired.bind(this);
    this.setFlightSubFieldsMissing = this.setFlightSubFieldsMissing.bind(this);
  }

  getInitialState() {
    return {
      ioProductForm: [],
      ioProductData: {},
      ioProductPricingFields: [],
      editingName: false,
      errors: [],
      flighted: false,
      flights: [{}],
      newIoProductService: null,
      newIoProductName: null,
      newIoProductServiceNiceName: null,
      mainService: null,
      subOptions: null,
      requiredMissing: false,
      flightSubFieldsMissing: false,
    };
  }

  onChange(e, data, fieldId) {
    let self = this;
    if (fieldId === "name") {
      this.setState(
        {
          newIoProductName: e.target.value,
        },
        function () {
          self.checkRequired();
        }
      );
    } else if (fieldId === "flights") {
      this.setState(
        {
          flights: data,
        },
        this.checkRequired
      );
    } else {
      let ioProductData = Object.assign({}, this.state.ioProductData);
      ioProductData[fieldId] = data;

      this.setState(
        {
          ioProductData: ioProductData,
        },
        function () {
          self.checkRequired();
        }
      );

      if (typeof this.props.onChange === "function") {
        this.props.onChange(ioProductData);
      }
    }
  }

  editName() {
    this.setState({
      editingName: true,
    });
  }

  onSelectService(e, data) {
    let service = data.value;
    let configItem = Flagship.config.lineItemServices.find(function (element) {
      return element.value === service;
    });

    if (configItem.hasOwnProperty("subOptions")) {
      this.setState({
        mainService: configItem,
        subOptions: configItem.subOptions.filter((item) => {
          return item.deactivated ? false : true;
        }),
      });
    } else {
      let flighted = configItem.flighted;
      service = configItem.text;

      this.setState(
        {
          newIoProductService: data.value,
          newIoProductServiceNiceName: service,
          newIoProductName: service,
          flighted,
        },
        function () {
          let self = this;

          Flagship.get(
            "fields/io-product_" + this.state.newIoProductService,
            {
              active: true,
            },
            function (response) {
              if (response.data.success === true) {
                self.setState(
                  {
                    ioProductForm: response.data.results,
                  },
                  function () {
                    self.checkRequired();
                  }
                );
              } else {
                Flagship.error(
                  "Error getting Advisr IO product form from Flagship API server.",
                  self.props.recordId,
                  self.props.userId
                );
              }
            },
            function (err) {
              Flagship.error(
                "Error getting Advisr IO product form from Flagship API server: " +
                  err,
                self.props.recordId,
                self.props.userId
              );
            }
          );
        }
      );
    }
  }

  onSelectSubOption(e, data) {
    let subService = data.value;
    let configItem = this.state.mainService.subOptions.find(function (element) {
      return element.value === subService;
    });

    let service = this.state.mainService.text + " - " + configItem.text;
    let flighted = configItem.flighted;

    this.setState(
      {
        newIoProductService: data.value,
        newIoProductServiceNiceName: service,
        newIoProductName: service,
        flighted,
      },
      function () {
        let self = this;

        // First get main service fields
        Flagship.get(
          "fields/io-product_" + this.state.mainService.value,
          {
            active: true,
            instance: this.props.instance,
          },
          function (response) {
            if (response.data.success === true) {
              self.setState(
                {
                  ioProductForm: response.data.results,
                },
                function () {
                  self.getSubServiceFields();
                }
              );
            } else {
              Flagship.error(
                "Error getting Advisr IO product form from Flagship API server.",
                self.props.recordId,
                self.props.userId
              );
            }
          },
          function (err) {
            Flagship.error(
              "Error getting Advisr IO product form from Flagship API server: " +
                err,
              self.props.recordId,
              self.props.userId
            );
          }
        );
      }
    );
  }

  getSubServiceFields() {
    let self = this;

    // Then add sub service fields
    Flagship.get(
      "fields/io-product_" + this.state.newIoProductService,
      {
        active: true,
      },
      function (response) {
        if (response.data.success === true) {
          let combinedForm = [
            ...self.state.ioProductForm,
            ...response.data.results,
          ];

          self.setState(
            {
              ioProductForm: combinedForm,
            },
            function () {
              self.checkRequired();
            }
          );
        } else {
          Flagship.error(
            "Error getting Advisr IO product form from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting Advisr IO product form from Flagship API server: " +
            err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  addError(fieldId) {
    let errors = this.state.errors;

    if (errors.indexOf(fieldId) !== -1) {
      errors.push(fieldId);
    }

    this.setState({
      errors: errors,
    });
  }

  clearError(fieldId) {
    let errors = this.state.errors;
    for (var i = errors.length - 1; i >= 0; i--) {
      if (errors[i] === fieldId) {
        errors.splice(i, 1);
      }
    }

    this.setState({
      errors: errors,
    });
  }

  setFlightSubFieldsMissing(flightSubFieldsMissing) {
    this.setState(
      {
        flightSubFieldsMissing,
      },
      this.checkRequired
    );
  }

  saveAndExit() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;

    Flagship.post(
      "io-product/create/" + self.props.recordId,
      {
        io_product_name: self.state.newIoProductName,
        io_product_type: self.state.newIoProductService,
        data: self.state.ioProductData,
        flights: self.state.flights,
      },
      function (response) {
        if (response.data.success === true) {
          Flagship.notify("Line item created.", "success");
          Flagship.event(
            "create-io-product",
            {
              ioProductId: response.data.ioProductId,
              ioProductKey: response.data.io_product_key,
              ioProductName: self.state.newIoProductName,
              ioProductType: self.state.newIoProductService,
              data: self.state.ioProductData,
            },
            self.props.recordId,
            self.props.userId
          );
          self.setState(self.getInitialState(), function () {
            if (typeof self.props.onAddIoProduct === "function") {
              self.props.onAddIoProduct();
            }
          });
        } else {
          Flagship.error(
            "Error adding Advisr IO product.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error adding Advisr IO product: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  checkRequired() {
    let requiredMissing = false;
    let self = this;

    typeof this.state.ioProductForm !== "undefined" &&
      this.state.ioProductForm.length &&
      this.state.ioProductForm.map(function (item) {
        if (
          self.state.flightSubFieldsMissing ||
          ((item.required === true || item.required === 1) &&
            empty(self.state.ioProductData[item.field_id]) &&
            shouldShowField(item, self.state.ioProductData))
        ) {

          requiredMissing = true;
        }
      });

    this.setState({
      requiredMissing: requiredMissing,
    });
  }

  render() {
    if (empty(this.state.ioProductForm)) {
      return (
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="5">
                <Loader className="flagship-loader" active inline="centered" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    } else {
      let self = this;
      let serviceOptions = JSON.parse(
        JSON.stringify(Flagship.config.lineItemServices)
      ).filter((item) => {
        return item.deactivated ? false : true;
      });
      serviceOptions = serviceOptions.map(function (item) {
        if (item.hasOwnProperty("subOptions")) {
          delete item["subOptions"];
        }
        return item;
      });

      return (
        <Modal
          open={true}
          onClose={this.props.cancelAddNew}
          closeIcon
          closeOnDimmerClick={false}
        >
          <Header icon="pin" content="Add New Product from Advisr" />
          <Modal.Content>
            {this.state.newIoProductService === null ? (
              <div>
                <p>
                  Please add each product that sold (from the Advisr proposal).
                </p>
                <Select
                  style={{ marginRight: "5px" }}
                  placeholder="Select a Service"
                  options={serviceOptions}
                  onChange={(e, data) => {
                    self.onSelectService(e, data);
                  }}
                />
                {this.state.subOptions !== null ? (
                  <Select
                    placeholder="Specific Service"
                    options={this.state.subOptions}
                    onChange={(e, data) => {
                      self.onSelectSubOption(e, data);
                    }}
                  />
                ) : null}
              </div>
            ) : (
              <div>
                {this.state.editingName === true ? (
                  <Header as="h3" color="grey">
                    <div className="ui input">
                      <input
                        autoFocus
                        placeholder={self.state.newIoProductName}
                        onChange={(e, data) => self.onChange(e, data, "name")}
                        style={{
                          minWidth: "400px",
                          maxWidth: "100%",
                        }}
                      />
                    </div>
                    <span className="margin-left">
                      {" (" + this.state.newIoProductServiceNiceName + ")"}
                    </span>
                  </Header>
                ) : (
                  <Header
                    as="h3"
                    onClick={self.editName}
                    className="hover-dotted-outline"
                  >
                    {self.state.newIoProductName +
                      (self.state.newIoProductName !==
                      this.state.newIoProductServiceNiceName
                        ? "(" + this.state.newIoProductServiceNiceName + ")"
                        : "")}
                  </Header>
                )}

                {this.state.flighted === true ? (
                  <div className="flight-field-container clearfix">
                    <FlightField
                      {...this.props.attributes}
                      fields={this.props.options}
                      value={this.state.flights}
                      fieldId="flights"
                      onChange={(e, data) => {
                        this.onChange(e, data, "flights");
                      }}
                      recordType="IO"
                      callrail={this.state.newIoProductService === "callrail"}
                      email={
                        this.state.newIoProductService === "email-marketing"
                      }
                      social={
                        this.state.newIoProductService === "social-media-ads"
                      }
                      setFlightSubFieldsMissing={this.setFlightSubFieldsMissing}
                    />
                  </div>
                ) : null}

                {this.state.ioProductForm.length &&
                  this.state.ioProductForm.map(function (item, i) {
                    let fieldId = item.id;
                    return shouldShowField(item, self.state.ioProductData) ? (
                      <Field
                        contentType="ioProduct"
                        addError={self.addError}
                        clearError={self.clearError}
                        model={"IoProduct." + i}
                        key={"field-" + i}
                        value={!empty(item.value) ? item.value : null}
                        default={self.state.ioProductData[fieldId]}
                        filterInput={
                          item.validation !== "" ? item.validation : null
                        }
                        onChange={(e, data, fieldId) =>
                          self.onChange(e, data, fieldId)
                        }
                        {...item}
                      />
                    ) : null;
                  })}
              </div>
            )}
          </Modal.Content>
          <Modal.Actions>
            {this.state.requiredMissing ? (
              <span className="red-text">
                {this.state.flightSubFieldsMissing
                  ? "Missing required flight data."
                  : "Required fields missing."}
              </span>
            ) : null}
            <Button
              disabled={
                this.state.newIoProductService === null ||
                this.state.requiredMissing
              }
              primary
              onClick={this.saveAndExit}
            >
              <Icon name="plus" /> Add Product
            </Button>
            <Button color="grey" onClick={this.props.cancelAddNew}>
              <Icon name="dont" /> Cancel
            </Button>
          </Modal.Actions>
        </Modal>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    instance: state.main.instance,
  };
}

export default connect(mapStateToProps, null)(IoProductAdvisrForm);



// WEBPACK FOOTER //
// ./src/components/modals/IoProductAdvisrAddModal.js